import React from 'react';
import { ChevronDown } from 'lucide-react';
export const ScrollIndicator: React.FC = () => {
  return <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-40 animate-bounce">
      <div className="flex flex-col items-center gap-2">
        
        
      </div>
    </div>;
};